import React, { useEffect, useState, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ShoppingCart, Gift, X } from "lucide-react";
import axios from "axios";
import GiftVoucherPaymentModal from "../components/GiftVoucherPaymentModal";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useModal } from "../context/ModalContext";
import { flyToCart } from "../utils/flyToCart";
import { useSettings } from "../context/SettingsContext";
const GiftVoucher = () => {
  const [vouchers, setVouchers] = useState([]);
  const [voucherCart, setVoucherCart] = useState([]);
  const [baseurl, setBaseUrl] = useState("");
  const [showCart, setShowCart] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState(false);
const [deleteId, setDeleteId] = useState(null);
const { settings } = useSettings();

const [acceptedTerms, setAcceptedTerms] = useState(false);
const [showTermsModal, setShowTermsModal] = useState(false);

  const navigate = useNavigate();
  const [recipientInfo, setRecipientInfo] = useState({
    recipientType: "self",
    recipient: { name: "", email: "", phone: "" },
  });
  const { openLogin, openRegister } = useModal();
   const cartIconEl = document.querySelector(".gcart-icon");
   const addBtnRef = useRef(null);

    const user = useSelector((state) => state.auth.user); 
const [tempOrderId, setTempOrderId] = useState(null);

const createTempOrder = async () => {
  try {
    if (!user?.id) {
      openLogin();
      return;
    }

    const payload = {
      user_id: user.id,
      vouchers: voucherCart,
      recipient: recipientInfo,
      total_amount: total,
      currency: localStorage.getItem("currency_name") || "USD",
    };

    const { data } = await axios.post(
      `${window.BASE_API_URL}create-giftvoucher-temp`,
      payload
    );

    if (data?.success) {
      setTempOrderId(data.temp_order_id);
      setShowPaymentModal(true);
    } else {
      toast.error("Unable to initialize order.");
    }
  } catch (err) {
    console.error(err);
    toast.error("Failed to create temporary order.");
  }
};

  // ✅ STEP 1: Restore cart & recipient immediately from localStorage (before API)
  useEffect(() => {
    try {
      const storedCart = localStorage.getItem("voucherCart");
      const storedRecipient = localStorage.getItem("recipientInfo");
      // console.log(storedCart);
      if (storedCart) {
        const parsedCart = JSON.parse(storedCart);
        setVoucherCart(parsedCart);
      }

      if (storedRecipient) {
        setRecipientInfo(JSON.parse(storedRecipient));
      }
    } catch (err) {
      console.warn("⚠️ Failed to restore cart:", err);
    }
  }, []);


  const saveGiftVoucherOrder = async (paymentIntent) => {
  try {
   
    const userId = user?.id; // adjust based on your actual key

    const payload = {
      user_id: userId,
      payment_id: paymentIntent.id,
      payment_status: paymentIntent.status,
      payment_method: paymentIntent.payment_method_types?.[0] || "stripe",
      amount: paymentIntent.amount / 100, // Stripe returns in cents
      currency: paymentIntent.currency,
      vouchers: voucherCart.map((item) => ({
        id: item.id,
        name: item.name,
        price: item.sales_price,
        message: item.message,
      })),
      recipient: recipientInfo,
    };

    // console.log("Saving Gift Voucher Order:", payload);

    const { data } = await axios.post(
      `${window.BASE_API_URL}save-giftvoucher-order`,
      payload
    );

    if (data?.success) {
      toast.success("🎁 Gift Vouchers saved to your account successfully!");
    } else {
      toast.error("⚠️ Failed to save order. Please contact support.");
    }
  } catch (error) {
    console.error("❌ Error saving gift voucher order:", error);
    toast.error("❌ Something went wrong saving your order.");
  }
};


  // ✅ STEP 2: Fetch vouchers from API (do NOT reset cart)
  useEffect(() => {
    const fetchVouchers = async () => {
      try {
        const res = await axios.get(`${window.BASE_API_URL}giftvoucher`);
        if (res.data.success) {
          setBaseUrl(res.data.baseurl);
          setVouchers(res.data.data);
        }
      } catch (error) {
        console.error("Error fetching vouchers:", error);
      }
    };
    fetchVouchers();
  }, []);


  // ✅ Validate cart vouchers with latest available vouchers
useEffect(() => {
  if (!vouchers.length) return;

  setVoucherCart((prevCart) => {
    const validatedCart = prevCart.filter((cartItem) => {
      const currentVoucher = vouchers.find(
        (v) => v.id === cartItem.id
      );

      // ❌ If voucher no longer exists
      if (!currentVoucher) {
        toast.error(`${cartItem.name} is no longer available.`);
        return false;
      }

      // ❌ If amount or price changed
      if (
        Number(currentVoucher.sales_price) !==
        Number(cartItem.sales_price)
      ) {
        toast.warning(
          `${cartItem.name} price updated to ${currentVoucher.sales_price}`
        );

        // Update price automatically
        cartItem.sales_price = currentVoucher.sales_price;
      }

      return true;
    });

    localStorage.setItem("voucherCart", JSON.stringify(validatedCart));
    return [...validatedCart];
  });
}, [vouchers]);


  useEffect(() => {
    try {
      localStorage.setItem("recipientInfo", JSON.stringify(recipientInfo));
    } catch (err) {
      console.warn("⚠️ Failed to save recipientInfo:", err);
    }
  }, [recipientInfo]);

  // ✅ Add, update, remove items
 const addToVoucherCart = (voucher, ev) => {


  const newItem = {
    ...voucher,
    cartId: Date.now(),
    message: "",
    image: voucher.image?.startsWith("http")
      ? voucher.image
      : `${baseurl}${voucher.image}`,
  };

  setVoucherCart((prev) => {
    const updatedCart = [...prev, newItem];
    localStorage.setItem("voucherCart", JSON.stringify(updatedCart)); // ✅ save immediately
    return updatedCart;
  });

    if (addBtnRef.current && cartIconEl) {
      // alert();
        flyToCart(baseurl+voucher.image, ev, cartIconEl);
      }

  

  toast.success(`${voucher.name} added to cart!`);
};


  const updateCartItem = (cartId, field, value) => {
    setVoucherCart((prev) =>
      prev.map((item) =>
        item.cartId === cartId ? { ...item, [field]: value } : item
      )
    );
  };

  const removeFromCart = (cartId) => {
    setVoucherCart((prev) => prev.filter((v) => v.cartId !== cartId));
  };

  // const total = voucherCart.reduce((sum, v) => sum + Number(v.sales_price || 0), 0);
  const subtotal = voucherCart.reduce(
  (sum, v) => sum + Number(v.sales_price || 0),
  0
);

const taxPercent = Number(settings?.voucher_tax || 0);
const taxAmount = taxPercent > 0 ? (subtotal * taxPercent) / 100 : 0;

const total = subtotal + taxAmount;
  const toggleCart = () => setShowCart((prev) => !prev);

  return (
    <div className="min-h-screen bg-gradient-to-b from-amber-50 to-white py-12 px-4 sm:px-8">
      <div className="max-w-6xl mx-auto">
        <h1 className="text-4xl font-extrabold text-center text-amber-700 mb-10 flex items-center justify-center gap-2"  style={{ color: settings?.cart_btn_color || "#111827" }}>
          <Gift className="w-10 h-10 text-amber-600"  />
          Gift Vouchers
        </h1>

        {/* Voucher Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {vouchers.map((voucher) => (
            <motion.div
              key={voucher.id}
              whileHover={{ scale: 1.04 }}
              className="bg-white rounded-2xl shadow-lg hover:shadow-amber-200 transition-all duration-300 overflow-hidden border border-amber-100"
            >
              <div className="relative">
                <img
                  src={`${baseurl}${voucher.image}`}
                  alt={voucher.name}
                  className="w-full h-56 object-cover"
                />
                <span className="absolute top-3 right-3 bg-amber-600 text-white text-sm px-3 py-1 rounded-full">
                  ${voucher.amount}
                </span>
              </div>

              <div className="p-6 flex flex-col justify-between h-[220px]">
                <div>
                  <h2 className="text-xl font-bold text-amber-800 mb-2"  style={{ color: settings?.cart_title_color || "#111827" }}>
                    {voucher.name}
                  </h2>
                  <p className="text-gray-600 text-sm mb-3">
                    {voucher.description}
                  </p>
                 {/* {item.type == 'first_offer' &&  <span className="bg-blue-100 text-blue-800 text-sm font-medium px-2.5 py-0.5 rounded-full">
  First Offer Item
</span>} */}
                </div>

                <div className="flex items-center justify-between mt-4">
                  <div className="text-lg font-bold text-amber-700"  style={{ color: settings?.cart_title_color || "#111827" }}>
                    {localStorage.getItem('currency')} {voucher.sales_price}
                    <span className="text-gray-400 text-sm line-through ml-2">
                      ${voucher.amount}
                    </span>
                  </div>
                  <button
                    ref={addBtnRef}

                     style={{
                  background: settings?.cart_btn_color || "#000000ff",
                  color: settings?.cart_btn_text_color || "#ffffff",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background =
                    settings?.cart_btn_hover || "#f59e0b";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background =
                    settings?.cart_btn_color || "#ffffff";
                }}

                    className="bg-amber-600 hover:bg-amber-700 text-white rounded-full px-4 py-2 flex items-center gap-2 transition"
                 onClick={(e) => addToVoucherCart(voucher, e.currentTarget)}
                  >
                    <ShoppingCart className="w-4 h-4" />
                    Add
                  </button>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Floating Cart Button */}
        {voucherCart && voucherCart.length > 0 && (
          <motion.button
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.95 }}
            onClick={toggleCart}
             style={{
                  background: settings?.cart_btn_color || "#000000ff",
                  color: settings?.cart_btn_text_color || "#ffffff",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background =
                    settings?.cart_btn_hover || "#f59e0b";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background =
                    settings?.cart_btn_color || "#ffffff";
                }}
            className=" gcart-icon fixed bottom-6 right-6 bg-amber-600 hover:bg-amber-700 text-white rounded-full p-4 shadow-lg z-50 flex items-center justify-center"
          >
            <ShoppingCart className="w-6 h-6" />
            <span className="absolute -top-1 -right-1 bg-white text-amber-700 font-bold text-xs rounded-full px-1.5">
              {voucherCart.length}
            </span>
          </motion.button>
        )}

        {/* Voucher Cart Sidebar */}
        <AnimatePresence>
          {showCart && (
            <motion.div
              initial={{ x: 400 }}
              animate={{ x: 0 }}
              exit={{ x: 400 }}
              className="fixed right-0 top-0 h-full w-96 bg-white shadow-2xl border-l border-amber-200 p-6 z-50 overflow-y-auto"
            >
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-2xl font-bold text-amber-700"  style={{ color: settings?.cart_btn_color || "#111827" }}>🎁 Your Vouchers</h3>
                <button
                  onClick={() => setShowCart(false)}
                  className="text-gray-500 hover:text-red-500"
                >
                  <X className="w-6 h-6" />
                </button>
              </div>

              {voucherCart.map((item) => (
                <div key={item.cartId} className="mb-6 border-b border-amber-100 pb-4">
                  <div className="flex justify-between items-center mb-2">
                    <div>
                      <p className="font-semibold text-amber-800"  style={{ color: settings?.cart_title_color || "#111827" }}>{item.name}</p>
                      <p className="text-sm text-gray-500"> {localStorage.getItem('currency')} {item.sales_price}</p>
                    </div>
                   <button
  onClick={() => {
    setDeleteId(item.cartId);
    setConfirmDelete(true);
  }}
  className="text-gray-400 hover:text-red-500"
>
  <X className="w-4 h-4" />
</button>

                  </div>

                  <img
                    src={item.image}
                    alt={item.name}
                    className="w-full h-28 object-cover rounded-lg mb-3"
                  />

                  <textarea
                    className="w-full border border-amber-200 rounded-lg p-2 text-sm mb-3 focus:ring-2 focus:ring-amber-300 outline-none"
                    placeholder="Write a message for this voucher..."
                    value={item.message}
                    onChange={(e) =>
                      updateCartItem(item.cartId, "message", e.target.value)
                    }
                  />
                </div>
              ))}

              {/* Full Cart Recipient Info */}
              <div className="border-t border-amber-200 pt-4">
                <label className="text-sm font-semibold text-gray-700">
                  Who is it for?
                </label>
                <select
                  className="w-full border border-amber-200 rounded-lg p-2 text-sm mt-1 focus:ring-2 focus:ring-amber-300 outline-none"
                  value={recipientInfo.recipientType}
                  onChange={(e) =>
                    setRecipientInfo((prev) => ({
                      ...prev,
                      recipientType: e.target.value,
                    }))
                  }
                >
                  <option value="self">Self</option>
                  <option value="other">Other</option>
                </select>

                {recipientInfo.recipientType === "other" && (
                  <div className="space-y-2 mt-2">
                    <input
                      type="text"
                      placeholder="Recipient Name"
                      className="w-full border border-amber-200 rounded-lg p-2 text-sm focus:ring-2 focus:ring-amber-300 outline-none"
                      value={recipientInfo.recipient.name}
                      onChange={(e) =>
                        setRecipientInfo((prev) => ({
                          ...prev,
                          recipient: { ...prev.recipient, name: e.target.value },
                        }))
                      }
                    />
                    <input
                      type="email"
                      placeholder="Recipient Email"
                      className="w-full border border-amber-200 rounded-lg p-2 text-sm focus:ring-2 focus:ring-amber-300 outline-none"
                      value={recipientInfo.recipient.email}
                      onChange={(e) =>
                        setRecipientInfo((prev) => ({
                          ...prev,
                          recipient: { ...prev.recipient, email: e.target.value },
                        }))
                      }
                    />
                    <input
                      type="tel"
                      placeholder="Recipient Phone"
                      className="w-full border border-amber-200 rounded-lg p-2 text-sm focus:ring-2 focus:ring-amber-300 outline-none"
                      value={recipientInfo.recipient.phone}
                      onChange={(e) =>
                        setRecipientInfo((prev) => ({
                          ...prev,
                          recipient: { ...prev.recipient, phone: e.target.value },
                        }))
                      }
                    />
                  </div>
                )}
              </div>

              {/* Total + Payment */}
              <div className="mt-6">
               <div className="space-y-1 mb-4 text-sm">
  <div className="flex justify-between">
    <span>Subtotal</span>
    <span>
      {localStorage.getItem("currency")} {subtotal.toFixed(2)}
    </span>
  </div>

  {taxPercent > 0 && (
    <div className="flex justify-between">
      <span>Tax ({taxPercent}%)</span>
      <span>
        {localStorage.getItem("currency")} {taxAmount.toFixed(2)}
      </span>
    </div>
  )}

  <div className="flex justify-between font-bold text-lg border-t pt-2">
    <span>Total</span>
    <span>
      {localStorage.getItem("currency")} {total.toFixed(2)}
    </span>
  </div>
</div>


{settings?.is_gift_voucher_terms == 1 && (
  <div className="flex items-start gap-2 mt-4 text-sm">
    <input
      type="checkbox"
      checked={acceptedTerms}
      onChange={(e) => setAcceptedTerms(e.target.checked)}
      className="mt-1"
    />
    <label>
      I agree to{" "}
      <span
        onClick={() => setShowTermsModal(true)}
        className="text-blue-600 underline cursor-pointer"
      >
        Terms & Conditions
      </span>
    </label>
  </div>
)}

                {user?.id  ? 
                <button
                  onClick={() => {
    if (settings?.is_gift_voucher_terms == 1 && !acceptedTerms) {
      toast.error("Please accept Terms & Conditions");
      return;
    }
    createTempOrder();
  }}
                  style={{
                  background: settings?.cart_btn_color || "#000000ff",
                  color: settings?.cart_btn_text_color || "#ffffff",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background =
                    settings?.cart_btn_hover || "#f59e0b";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background =
                    settings?.cart_btn_color || "#ffffff";
                }}

  //               disabled={
  //   settings?.is_gift_voucher_terms == 1 && !acceptedTerms
  // }

                  className="w-full bg-amber-600 hover:bg-amber-700 text-white rounded-full py-3 text-lg transition"
                >
                  Proceed to Payment
                </button>
                
              : (<div className="flex gap-2 mt-4">
        <button
          onClick={openLogin}
          className="bg-orange-500 text-white w-full py-3 rounded-lg font-bold"
        >
          Login
        </button>

        <button
          onClick={openRegister}
          className="bg-orange-500 text-white w-full py-3 rounded-lg font-bold"
        >
          Register
        </button></div>)}
              </div>
            </motion.div>
          )}
        </AnimatePresence>

        {/* Payment Modal */}
       <GiftVoucherPaymentModal
  isOpen={showPaymentModal}
  onClose={() => setShowPaymentModal(false)}
  amount={total}
  onSuccess={async (paymentIntent) => {
    // console.log("Payment successful for Gift Vouchers:", paymentIntent);

    // ✅ 1. Save to user account
    await saveGiftVoucherOrder(paymentIntent);

    // ✅ 2. Clear local storage and UI
    toast.success("🎁 Gift Vouchers Purchased Successfully!");
    setVoucherCart([]);
    localStorage.removeItem("voucherCart");
    localStorage.removeItem("recipientInfo");
    setRecipientInfo({
      recipientType: "self",
      recipient: { name: "", email: "", phone: "" },
    });
    setShowPaymentModal(false);
    setShowCart(false);

      setTimeout(() => {
        navigate("/thank-you-gift");
      }, 800);
  }}
  tempOrderId={tempOrderId}
/>
{/* Delete Confirmation Modal */}
<AnimatePresence>
  {confirmDelete && (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 bg-black/50 flex items-center justify-center z-[999]"
    >
      <motion.div
        initial={{ scale: 0.8 }}
        animate={{ scale: 1 }}
        exit={{ scale: 0.8 }}
        className="bg-white p-6 rounded-xl shadow-xl w-80"
      >
        <h3 className="text-lg font-bold text-red-600 mb-2">
          Remove Voucher?
        </h3>
        <p className="text-sm text-gray-600 mb-4">
          Are you sure you want to delete? .
        </p>

        <div className="flex justify-end gap-3">
          <button
            className="px-4 py-2 rounded-lg bg-gray-200"
            onClick={() => setConfirmDelete(false)}
          >
            Cancel
          </button>

          <button
            className="px-4 py-2 rounded-lg bg-red-600 text-white"

            
            onClick={() => {
              // Delete permanently
              setVoucherCart((prev) => {
                const updated = prev.filter((v) => v.cartId !== deleteId);
                localStorage.setItem("voucherCart", JSON.stringify(updated));
                return updated;
              });

              setConfirmDelete(false);
              setDeleteId(null);
            }}
          >
            Delete
          </button>
        </div>
      </motion.div>
    </motion.div>
  )}
</AnimatePresence>


<AnimatePresence>
  {showTermsModal && (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 bg-black/50 flex items-center justify-center z-[999]"
    >
      <motion.div
        initial={{ scale: 0.9 }}
        animate={{ scale: 1 }}
        exit={{ scale: 0.9 }}
        className="bg-white p-6 rounded-xl shadow-xl w-[500px] max-h-[80vh] overflow-y-auto"
      >
        <h3 className="text-lg font-bold mb-4">
          Gift Voucher Terms & Conditions
        </h3>

        <div
          className="text-sm text-gray-700"
          dangerouslySetInnerHTML={{
            __html: settings?.gift_voucher_terms_and_condition || "",
          }}
        />

        <div className="flex justify-end mt-4">
          <button
            onClick={() => setShowTermsModal(false)}
            className="px-4 py-2 rounded-lg bg-amber-600 text-white"
          >
            Close
          </button>
        </div>
      </motion.div>
    </motion.div>
  )}
</AnimatePresence>

      </div>
    </div>
  );
};

export default GiftVoucher;
